import { render, staticRenderFns } from "./FormAreaJoker.vue?vue&type=template&id=5268761c&scoped=true&"
import script from "./FormAreaJoker.vue?vue&type=script&lang=js&"
export * from "./FormAreaJoker.vue?vue&type=script&lang=js&"
import style0 from "./FormAreaJoker.vue?vue&type=style&index=0&id=5268761c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5268761c",
  null
  
)

export default component.exports